import { render } from "./ConfirmUpdateForm.vue?vue&type=template&id=aa03c0d6"
import script from "./ConfirmUpdateForm.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__